module.exports = __webpack_public_path__ + "img/empty.50cf9128.svg";